<template lang="pug">
    .post-heading
        h4.is-size-6-desktop.is-size-7-touch.is-uppercase.has-text-primary(v-if="subHeading") {{ subHeading }}
        h3.is-size-4-desktop.is-size-4-tablet.is-size-4-mobile(v-if="heading") {{ heading }}
</template>

<script>

import _ from 'lodash'

export default {
    name: 'Heading',
    props: {
        heading: {
            type: String,
        },
        subHeading: {
            type: String,
        },
    },
}
</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';

    .content .post-heading
        h3
            margin-top: 0
            color: $primary
            font-weight: 500
            margin-bottom: 0
        h4
            margin-bottom: 0
            font-weight: 900
            letter-spacing: 0

</style>
